import router from "next/router";

interface Href {
  pathname: string;
  query: {
    activityPanel?: string;
    levelId: string;
    powerWordsActivityId?: string;
    quizId?: string;
    writePromptId?: string;
  };
}

const updateLevelIdAndResetActivityQueryParams = async (levelId: string) => {
  const { query, pathname } = router;
  const href: Href = {
    pathname,
    query: {
      ...query,
      levelId,
    },
  };

  delete href.query.activityPanel;
  delete href.query.powerWordsActivityId;
  delete href.query.quizId;
  delete href.query.writePromptId;

  await router.replace(href, undefined, { shallow: true });
};

export default updateLevelIdAndResetActivityQueryParams;
